import { bound } from "@frui.ts/helpers";
import { watchBusy } from "@frui.ts/screens";
import { Modules } from "config";
import { computed, observable } from "mobx";
import EnumService from "services/enumService";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import CreateViewModel from "viewModels/createViewModel";
import RoleUserRepository from "repositories/roleUserRepository";
import User from "entities/user";
import type { interfaces } from "inversify";
import UserRepository from "repositories/userRepository";
import AlertsViewModel from "viewModels/alertsViewModel";

export default class RoleUserCreateViewModel extends CreateViewModel<User> {
  readonly modelName = "user";

  @observable showModal = false;
  @observable userOptions: any[] = [];
  @observable user = new User();

  constructor(
    protected itemId: string,
    protected repository: RoleUserRepository,
    protected userRepository: UserRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected enumService: EnumService,
    public alertsViewModel: AlertsViewModel,
    protected eventBus: EventBus
  ) {
    super();
  }

  @computed
  get name() {
    return this.translate("name");
  }

  @watchBusy
  protected async loadDetail() {
    const users = await this.userRepository.getAll({ limit: 1000, offset: 0 });
    this.userOptions = users.items.map(user => {
      return {
        id: user.id,
        label: `${user.firstName} ${user.lastName}`,
      };
    });

    return this.user;
  }

  @bound
  onClose() {
    this.requestClose();
    this.showModal = false;
  }

  @bound
  @watchBusy
  async save() {
    try {
      await this.repository.create(this.user, this.itemId);
      this.onCreated();
      this.showModal = false;
    } catch (e) {}
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.users, `roleUsers.${code}`, size);
  }

  static Factory({ container }: interfaces.Context) {
    return (itemId: string) => {
      return new RoleUserCreateViewModel(
        itemId,
        container.get(RoleUserRepository),
        container.get(UserRepository),
        container.get(LocalizationService),
        container.get(NotificationService),
        container.get(EnumService),
        container.get(AlertsViewModel),
        container.get(EventBus)
      );
    };
  }
}
